const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');
// 费用明细列表
const expenseList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/productionCenter/expenseDetail/list.vue')),
    'expenseList'
  );
// 费用明细新建
const expenseAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/productionCenter/expenseDetail/add.vue')),
    'expenseAdd'
  );
// 费用明细修改
const expenseEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/productionCenter/expenseDetail/edit.vue')),
    'expenseEdit'
  );
// 费用明细详情
const expenseDetail = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/productionCenter/expenseDetail/detail.vue')),
    'expenseDetail'
  );
const productionRouter = {
  path: '/production',
  component: index,
  children: [
    {
      path: 'expenseList',
      name: 'expenseList',
      component: expenseList,
      meta: {
        keepAlive: true,
        title: '费用明细',
      },
    },
    {
      path: 'expenseAdd',
      name: 'expenseAdd',
      component: expenseAdd,
      meta: {
        keepAlive: true,
        title: '费用明细新建',
      },
    },
    {
      path: 'expenseEdit',
      name: 'expenseEdit',
      component: expenseEdit,
      meta: {
        keepAlive: true,
        title: '费用明细修改',
      },
    },
    {
      path: 'expenseDetail',
      name: 'expenseDetail',
      component: expenseDetail,
      meta: {
        keepAlive: true,
        title: '费用明细详情',
      },
    },
  ],
};
export default productionRouter;
